export default "__VITE_ASSET__CTFLxYB4__"